'use strict';

export default (Alpine) => {
    Alpine.tracker = (variable) => {
        typeof variable !== 'undefined' ? variable : void 0; // eslint-disable-line
    };
};
